
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import CardProchaineActivite from "@/components/card/CardProchaineActivite.vue";
import CardCalendrier from "@/components/card/CardCalendrier.vue";
import CardFc from "@/components/card/CardFC.vue";
import Alert, { TypeAlert } from "@/components/alert/Alert.vue";
import panelActivite from "@/components/panel/PanelActivite.vue";
import optionActivite from "@/components/option/OptionActivite.vue";
import Modal from "@/components/modal/Modal.vue";
import Cta from "@/components/buttons/Button.vue";
import Tag from "@/components/tags/Tag.vue";
import { data, login, timeline } from "@/store";
import {
  Activite,
  ActiviteRecensementState,
  ElementKey,
  ProchaineActivite,
  User,
} from "@/models";
import TimelineService from "@/services/timeline.service";
import { found, select, isSameDay } from "@/helpers";
import dayjs from "dayjs";

@Component({
  methods: {
    found,
    select,
    isSameDay,
  },
  components: {
    Sidebar,
    CardProchaineActivite,
    Cta,
    CardCalendrier,
    CardFc,
    Alert,
    panelActivite,
    optionActivite,
    Modal,
    Tag,
  },
})
/** "Formation Continue" (FC) listing page — activities of type "9" specifically. */
export default class Recyclage extends Vue {
  private dataReady = false;
  private filterTypes: ElementKey[] | null = null;

  async mounted(): Promise<void> {
    await this.dataTimeline();
    this.dataReady = true;
  }

  /** Loads all FC-type activities into the timeline store. */
  private async dataTimeline() {
    await timeline.activites({
      types: [{ id: "9", libelle: "FC" }],
      list: "ALL",
    });
  }

  /** Records the user's sign-up state for an FC activity, then refreshes the list. */
  private async setRecensementState(
    activite: string,
    state: ActiviteRecensementState
  ): Promise<void> {
    await TimelineService.recensement(activite, state);
    await this.dataTimeline();
  }

  private date(date: string, format = "DD/MM/YYYY"): string {
    return dayjs(date).format(format);
  }

  get prochaineActivite(): ProchaineActivite[] | null {
    return timeline.getProchaineActivite;
  }

  get activites(): Activite[] | null {
    return timeline.getActivites;
  }

  get typesActivite(): ElementKey[] | null {
    return data.getTypesActivite;
  }

  get TypeAlert(): any {
    return TypeAlert;
  }

  get context(): User | null {
    return login.getContext;
  }
}
